<template>
    <base-modal
        hide-footer
        hide-header
        size="lg"
        @close="$emit('closeForm')"
    >
        <div class="col-sm-12 editor-form">
            <h2 class="editor-header">
                {{ wasteBins && wasteBins.length > 1 ? $t('mixed_waste_bins.edit_multiple') : $t('mixed_waste_bins.edit') }}
            </h2>
            <div class="row">
                <!-- Show open contracts  -->
                <div class="col-12 nopads">
                    <span class="span-title">{{ $t('orders.contract') }}</span>
                    <select
                        id="contract"
                        v-model="form.contractId"
                        class="form-select form-select-sm mb-3"
                        :disabled="form.remove === '1'"
                    >
                        <option :value="null">
                            {{ $t('orders.select_contract') }}
                        </option>
                        <option
                            v-for="option in allLouhiContracts"
                            :key="option.id"
                            :value="option.id"
                        >
                            {{ option.name }}
                        </option>
                    </select>
                </div>

                <div class="col-12 nopads">
                    <span class="span-title">{{ $t('mixed_waste_bins.condition') }}</span>
                    <select
                        id="condition"
                        v-model="form.condition"
                        class="form-select form-select-sm mb-3"
                        :disabled="form.remove === '1'"
                    >
                        <option :value="null">
                            {{ $t('mixed_waste_bins.select_condition') }}
                        </option>
                        <option
                            v-for="option in getInfraEquipmentCondition()"
                            :key="option.value"
                            :value="option.value"
                        >
                            {{ option.name }}
                        </option>
                    </select>
                </div>

                <div class="col-12 nopads mt-2">
                    <input
                        id="checkbox_remove"
                        v-model="form.remove"
                        type="checkbox"
                        class="form-check-input me-2"
                        value="1"
                    >
                    <label
                        class="form-check-label"
                        for="checkbox_remove"
                    >
                        {{ $t('mixed_waste_bins.remove') }}
                    </label>
                </div>

                <div class="col-sm-12 button-container">
                    <button
                        class="btn btn-secondary form-button"
                        @click.stop="$emit('closeForm')"
                    >
                        {{ $t('common.cancel') }}
                    </button>
                    <button
                        class="btn btn-success form-button"
                        :disabled="loading"
                        @click.stop="submitMultiple"
                    >
                        {{ $t('common.save') }}
                    </button>
                </div>
            </div>
            <div
                v-if="loading"
                id="loader"
                class="spinner"
            />
        </div>
    </base-modal>
</template>

<script>
import {restApi} from "../mixins/RestApiMixin";
import {attachmentHelper} from "../mixins/AttachmentMixin";
import {workAssignmentHelper} from "../mixins/WorkAssignmentMixin";
import {infraEquipmentHelper} from "@/components/mixins/InfraEquipmentMixin.js";
import {timeUtils} from "../mixins/TimeUtils";
import BaseModal from "@/components/BaseModal";
import {inject} from "vue";

export default {
    name: "MixedWasteBinsBulkEditorDialog",
    emits: ['closeForm', 'closeAndUpdate'],
    components: {BaseModal},
    mixins: [workAssignmentHelper, restApi, timeUtils, attachmentHelper, infraEquipmentHelper ],
    props: {
        //wasteBins: null,
        wasteBins:  {type: Array, required: true },
        isObserver: Boolean,
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function (){
        return{
            form: {
                contractId: null,
                condition: null,
                remove: false,
            },
            loading: false,
            allLouhiContracts: [],
        }
    },
    mounted: function() {
        if (this.isObserver) {
            this.fetchContracts()
        }
    },
    methods: {
        submitMultiple:function (){

            if (!Array.isArray(this.wasteBins) || this.wasteBins.length === 0) {
                return this.fail();
            }

            this.loading = true;

            const params = {};

            if (this.form.remove) {
                params.remove = 1;
            } else {
                if (this.form.contractId != null) params.contract_id = this.form.contractId;
                if (this.form.condition != null && this.form.condition !== '') {
                    params.condition = this.form.condition;
                }
            }

            //TODO: Dont send IDs, lets send wastBinDTOs -> no need to refetch from Louhi -> current contract info available
            params.wastebins_list = [...this.wasteBins]
            this.restUpdate(this.mixedWasteBinsUrl, params, this.success, this.fail)
        },
        success: function () {
            this.loading = false
            this.$emit('closeAndUpdate')
        },
        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        },
        fetchContracts: function () {
            this.loading = true
            this.allLouhiContracts = []
            let now = new Date()
            var params = {}
            params.startDate = now.toISOString()
            params.showOnlyLouhiContracts = 1
            this.restFetchParams(this.contractOpenUrl,
                params,
                this.handleContracts)
        },
        handleContracts: function (results) {
            this.loading = false
            if (results.data) {
                this.allLouhiContracts = results.data
            }
        },
    },
};
</script>

<style scoped>

</style>
